module.exports = __webpack_public_path__ + "static/brass-dragon-digging-fb949e46ecfa1f41a3b4ef7d17ca49a3.jpg";